var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29814_1027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2941 0.293945C12.6848 -0.0966797 13.3191 -0.0966797 13.7098 0.293945L15.7098 2.29395C16.1004 2.68457 16.1004 3.31895 15.7098 3.70957C15.341 4.07832 14.7504 4.1002 14.3598 3.76895L14.0629 4.06582L12.5379 5.59082C12.2504 5.87832 12.1785 6.30645 12.2691 6.70332C12.5629 7.98145 12.2098 9.37832 11.2129 10.3752L6.16602 15.4158C5.38477 16.1971 4.11914 16.1971 3.33789 15.4158L0.587891 12.6658C-0.193359 11.8846 -0.193359 10.6189 0.587891 9.8377L5.63164 4.79082C6.62852 3.79395 8.02539 3.44395 9.30352 3.73457C9.69727 3.8252 10.1285 3.7502 10.4129 3.46582L11.9379 1.94082L12.2348 1.64395C11.9035 1.2502 11.9223 0.662695 12.2941 0.293945ZM3.10352 10.8533L5.14727 12.8971C5.34102 13.0908 5.65977 13.0908 5.85352 12.8971L8.89727 9.85332C9.09102 9.65957 9.09102 9.34082 8.89727 9.14707L6.85352 7.10332C6.65977 6.90957 6.34102 6.90957 6.14727 7.10332L3.10352 10.1471C2.90977 10.3408 2.90977 10.6596 3.10352 10.8533Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29814_1027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrink);
export default __webpack_public_path__ + "static/media/drink.d816c8d0222c50d18bd49af7c0c2da44.svg";
export { ForwardRef as ReactComponent };